
const main = document.querySelector('.main');

export function scrollTo(selector: string, offset: number): void {
  const target = document.querySelector<HTMLElement>(selector);
  if (!target) return;
  if (!main) return;

  // Calculate the top position relative to the main scroll container
  let top: number;
  if (main instanceof HTMLElement) {
    top = target.getBoundingClientRect().top + main.scrollTop - main.getBoundingClientRect().top;
  } else {
    // fallback for when main is <body> or window
    top = target.getBoundingClientRect().top + window.scrollY;
  }

  const scrollData: ScrollToOptions = {
    top: top - offset,
    behavior: 'smooth',
  };

  if (main instanceof HTMLBodyElement) {
    window.scrollTo(scrollData);
  } else if (main instanceof HTMLElement) {
    main.scrollTo(scrollData);
  }
}

export function scrollToTop(): void {
  if (!main) return;
  const scrollData: ScrollToOptions = {
    top: 0,
    behavior: 'smooth',
  };
  if (main instanceof HTMLBodyElement) {
    window.scrollTo(scrollData);
  } else if (main instanceof HTMLElement) {
    main.scrollTo(scrollData);
  }
}

export function scrollToBottom(): void {
  if (!main) return;
  let scrollHeight = 0;
  if (main instanceof HTMLElement) {
    scrollHeight = main.scrollHeight;
  } else {
    scrollHeight = document.body.scrollHeight;
  }
  const scrollData: ScrollToOptions = {
    top: scrollHeight,
    behavior: 'smooth',
  };
  if (main instanceof HTMLBodyElement) {
    window.scrollTo(scrollData);
  } else if (main instanceof HTMLElement) {
    main.scrollTo(scrollData);
  }
}
